<template>
    <div class="row">
        <div class="col-12 my-2">
            <div class="card-header-actions">

              <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-8 card-header-search-box">
                    <div class="input-group">
                      <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search" @keypress.enter="initList">
                      <div class="input-group-append">
                          <button class="all-btn search-btn" @click="initList">
                              <i class="fa fa-search"></i>
                          </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_CAD_BUILDING_FIELD_ADD')" @click="showCadastreBuildingFieldEditModal(null)">{{$t("action.add")}}</button>
              </div>
            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>Код</th>
                      <th>Текст</th>
                      <th>Текст(ru)</th>
                      <th>Мажбурий</th>
                      <th>Жойлашиши</th>
                      <th>Тури</th>
                      <th>Референс</th>
                      <th class="text-center">{{$t("realEstate.field.action")}}</th>
                  </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                  <tr v-for="result in results.data" :key="result.id">
                      <td>{{result.code}}</td>
                      <td>{{result.name}}</td>
                      <td>{{result.nameRu}}</td>
                      <td>{{result.required ? 'Ха' : 'Йўқ'}}</td>
                      <td>{{result.alignment === 1 ? 'Чап' : 'Ўнг'}}</td>
                      <td>{{result.type}}</td>
                      <td>{{result.reference ? result.reference.name : ''}}</td>
                      <td class="td-actions text-center">
                          <button class="all-btn edit-btn table-action" data-original-title="Edit"
                                  @click="showCadastreBuildingFieldEditModal(result)" v-if="!result.system">
                              <i class="fa fa-edit"></i>
                          </button>
                      </td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <CadastreBuildingFieldEditModal/>
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import CadastreBuildingFieldEditModal from '@/views/config/cadastre/CadastreBuildingFieldEditModal';

    export default {
        name: "CadastreBuildingFieldList",
        components: {
            'b-pagination': bPagination,
            CadastreBuildingFieldEditModal: CadastreBuildingFieldEditModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('cadastre/building/field/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            showCadastreBuildingFieldEditModal(data) {
                this.$eventBus.$emit('showCadastreBuildingFieldEditModal', data);
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('cadastreBuildingFieldChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>

</style>